import styled from 'styled-components';

export type DividerProps = {
    subtle?: boolean;
    semantic?: boolean;
};

const Ruler = styled.div<{ $subtle: boolean }>`
    border: 0;
    margin: 0;
    height: 1px;
    background-color: ${({ $subtle, theme }) => ($subtle ? theme.ColorBorderTertiary : theme.ColorBorderSecondary)};
`;

/**
 * @description The default behaviour is to render a visual divider using a 'div'
 * @param {object} props
 * @param {boolean} props.subtle If subtle is true the component colors are more faded
 * @param {boolean} props.semantic If semantic is true the component renders an 'hr', because the 'hr tag defines a semantic behaviour
 */
function Divider(props: DividerProps) {
    const { subtle = false, semantic = false } = props;

    return <Ruler as={semantic ? 'hr' : 'div'} $subtle={subtle} />;
}

export default Divider;
